export default "__VITE_ASSET__diTcUTwp__"